// this is an autogenerated file from App/Widget/Content/Questions/Complete/MedicalForm/Content/MedicalFormUrl/Content/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Widget_Content_Questions_Complete_MedicalForm_Content_MedicalFormUrl_Content_Content($patient_id: uuid!) {
  medical_form_generate_url(patient_id: $patient_id) {
    url
  }
}

`